import React from 'react';

/**
 * The Tailwind initials avatar used by the admin console.
 *
 * Its own module, rather than living in ui.tsx with the rest of the shared UI,
 * because ui.tsx imports @tremor/react. App.tsx needs an avatar for the admin
 * sidebar, and that single import was enough to pin Tremor and its charting
 * dependency into the entry chunk — which the public /welcome funnel downloads
 * too, despite never rendering a chart.
 *
 * Not to be confused with the `Avatar` in primitives.tsx: that one is the legacy
 * portal's `.profile-avatar`, a different look on a different surface.
 */

const AVATAR_BG = [
  'bg-blue-600', 'bg-violet-600', 'bg-emerald-600',
  'bg-amber-600', 'bg-rose-600', 'bg-cyan-600', 'bg-indigo-600',
];

export const Avatar: React.FC<{ name: string | null | undefined; size?: number }> = ({ name, size = 28 }) => {
  const initials = (name ?? '?')
    .split(' ')
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  const colorIdx = (name ?? '').charCodeAt(0) % AVATAR_BG.length;
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${AVATAR_BG[colorIdx]}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
    >
      {initials}
    </div>
  );
};
